import type { ReactNode } from "react"

import { cx } from "../lib/cx"
import styles from "./badge.module.css"

/**
 * Значок состояния.
 *
 * ЦВЕТ — НЕ НОСИТЕЛЬ СМЫСЛА. Смысл несёт подпись: «Подтверждена», «Не пришёл».
 * Цвет только ускоряет чтение уже знакомому человеку. Поэтому значка без подписи
 * в библиотеке нет, а точка-кружок — необязательное дополнение, а не замена слову.
 * Это то же правило, по которому в сетке журнала у статуса три канала различения
 * помимо цвета (ТЗ §2.3).
 */

export type BadgeTone = "ok" | "warn" | "info" | "gray" | "error" | "outline" | "brand"

const TONE_STYLE: Readonly<Record<BadgeTone, string | undefined>> = {
  ok: styles.ok,
  warn: styles.warn,
  info: styles.info,
  gray: styles.gray,
  error: styles.error,
  outline: styles.outline,
  brand: styles.brand,
}

export function Badge(props: {
  readonly children: ReactNode
  readonly tone?: BadgeTone
  /** Точка перед подписью — для рядов, где значки идут подряд и нужен ритм. */
  readonly dot?: boolean
  readonly className?: string | undefined
}): ReactNode {
  const { tone = "gray", dot = false } = props
  return (
    <span className={cx(styles.badge, TONE_STYLE[tone], props.className)}>
      {dot ? <span className={styles.dot} aria-hidden="true" /> : null}
      {props.children}
    </span>
  )
}
